import React from 'react';
import useSWR from 'swr';
import { useAuthInfo } from '@propelauth/react';
import { Grid } from '@mui/material';
import { UserAvailabilityCalendar } from './userAvailabilityCalendar/UserAvailabilityCalendar';
import { TabsPage } from '../common/components/TabsPage';
import { PermanentUserAvailability } from './permenantUserAvailability/PermanentUserAvailability';
import { UserPreferencesService } from '../api';
import { Qualifications } from './qualifications/Qualifications';
import { UserSyncSettings } from './UserSyncSettings';
import { mb } from '../common/theme/mbTokens';

enum UserAvailabilityPageTabs {
  CALENDAR_AVAILABILITY = 'calendaravailability',
  PERMANENT_AVAILABILITY = 'permanentavailability',
  QUALIFICATIONS = 'qualifications',
  USER_SYNC_SETTINGS = 'usersyncettings',
}

export const UserSettingsPage = () => {
  const { user: loggedInUser } = useAuthInfo();
  const selectedUserId = loggedInUser?.userId;
  const fullUserName = `${loggedInUser?.firstName} ${loggedInUser?.lastName}`;
  const {
    data: userPreferences,
    isLoading: isLoadingUserPreferences,
    mutate: refetchUserPrefs,
  } = useSWR(
    { opId: 'getUserPreferences', userId: selectedUserId },
    () => UserPreferencesService.getUserPreferences(selectedUserId),
    { refreshInterval: 20000 },
  );
  const tabContent = {
    [UserAvailabilityPageTabs.CALENDAR_AVAILABILITY]: (
      <UserAvailabilityCalendar
        userPreferences={userPreferences}
        isLoadingUserPreferences={isLoadingUserPreferences}
        refetchUserPrefs={refetchUserPrefs}
        selectedUserId={selectedUserId}
        fullUserName={fullUserName}
      />
    ),
    [UserAvailabilityPageTabs.PERMANENT_AVAILABILITY]: (
      <PermanentUserAvailability
        userPreferences={userPreferences}
        isLoadingUserPreferences={isLoadingUserPreferences}
        refetchUserPrefs={refetchUserPrefs}
        selectedUserId={selectedUserId}
      />
    ),
    [UserAvailabilityPageTabs.QUALIFICATIONS]: (
      <Qualifications
        userPreferences={userPreferences}
        isLoadingUserPreferences={isLoadingUserPreferences}
        refetchUserPrefs={refetchUserPrefs}
        selectedUserId={selectedUserId}
      />
    ),
    [UserAvailabilityPageTabs.USER_SYNC_SETTINGS]: (
      <UserSyncSettings
        userPreferences={userPreferences}
        isLoadingUserPreferences={isLoadingUserPreferences}
        refetchUserPrefs={refetchUserPrefs}
        selectedUserId={selectedUserId}
      />
    ),
  };
  return (
    <Grid
      container
      height="100%"
      overflow="hidden"
      flexDirection="column"
      flexWrap={'nowrap'}
      sx={{ gap: mb.layout.pageInset }}>
      <Grid container flexDirection="column" flexWrap="nowrap" sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
        <TabsPage tabContent={tabContent} />
      </Grid>
    </Grid>
  );
};
